import { connect } from 'react-redux';

import { selectors } from 'wanderu-ducks-browser-meta';

import SocialButtons from './SocialButtons';

function mapStateToProps(state) {
    return {
        capabilities: selectors.selectFeatureCapabilities(state),
    };
}

export default connect(mapStateToProps)(SocialButtons);
